var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPermission = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 13,
  height: 21,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M6.5 20a5.935 5.935 0 1 0 0-11.87A5.935 5.935 0 0 0 6.5 20"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M2.26 9.92V4.74C2.26 2.4 4.16.5 6.5.5 7.67.5 8.73.975 9.5 1.738a4.26 4.26 0 0 1 1.238 3.001v.848M6.5 14.065v1.696"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M6.5 14.489a1.272 1.272 0 1 0 0-2.543 1.272 1.272 0 0 0 0 2.543"
})));
export default SvgPermission;